import { NgModule }              from '@angular/core';
import { SharedModule }          from '../../shared/shared.module';
import {FormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RegistrationComponent }         from './registration.component';
import { routing }               from './registration.route';
import { HttpClientService } from '../../shared/http-client-service';

import { DialogModule } from 'primeng/dialog';
import { ConfigService } from '../../config/config.service';
import{BlockUIService} from"../../shared/services/blockui.service";
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

// Routed Feature module
@NgModule({
  imports:      [CommonModule,ReactiveFormsModule ,FormsModule, SharedModule,DialogModule,ButtonModule, routing ,RecaptchaModule, ProgressSpinnerModule],
  declarations: [ RegistrationComponent ],
  providers: [HttpClientService,ConfigService,BlockUIService]
})

export class RegistrationModule { }
